import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import isValidDnsName from '@/util/isValidDnsName';

export default function ServiceNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (newValue === '') {
      setError('Service name cannot be blank');
    } else if (!isValidDnsName(newValue)) {
      setError('Service name must be a valid DNS name');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Service Name'
          id='name'
          aria-describedby='name-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter a name for the service
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
